import { registerQueryFilterLabels } from 'components/organisms/filters/query-form/labels/QueryFilterLabels';
import { IStatementsSearch } from 'services/settlement/types';
import { selectWithLabel } from 'utils/components/inputs/selectWithLabel';

export const registerSettlementQueryFilters = (
  settlementPeriodOptions: { value: string | number; label: string }[],
) => {
  registerQueryFilterLabels<IStatementsSearch>(
    'settlement',
    {
      startSettlementPeriodId: selectWithLabel({
        labelKey: 'input.label.startSettlementPeriod',
        options: settlementPeriodOptions,
      }),
      endSettlementPeriodId: selectWithLabel({
        labelKey: 'input.label.endSettlementPeriod',
        options: settlementPeriodOptions,
      }),
    },
    {
      startSettlementPeriodId: ({ key, setValues }) => {
        setValues((prev) => ({ ...prev, [key]: '' as any }));
      },
      endSettlementPeriodId: ({ key, setValues }) => {
        setValues((prev) => ({ ...prev, [key]: '' as any }));
      },
    },
  );
};
